/* eslint-disable */
const mutations = {
  updateIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },

  setPostCategory(state, { postCategory }) {
    state.data = postCategory;
  },

  updatePostCategory(state, { postCategory }) {
    state.data = {
      ...state.data,
      ...postCategory,
    };
  },
};

export default mutations;
